import React from 'react'
import useExportDB from '../../hooks/useExportDB'
import './ImportExport.css';

function buttonText (status, progress) {
  if (status === 'IN-PROGRESS') {
    return `Exporting... ${progress}`
  }

  if (status === 'OK') {
    return 'Export successful!'
  }

  if (status === 'FAIL') {
    return 'Export error :('
  }

  return 'Export'
}

function Export () {
  const { state, handleExport } = useExportDB()
  return (
    <div className="import-export">
      <h3>Export database</h3>
      <p>Click the button below to export the database. It will export as a JSON file.</p>
      <button
        type="submit"
        disabled={state.status === 'IN-PROGRESS'}
        onClick={handleExport}
      >
        {buttonText(state.status, state.progress)}
      </button>
      {state.status === 'FAIL' && <p className="error">There was an error!</p>}
    </div>
  )
}

export default Export
